function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Sale",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "sprzedaz",
  transform: "translate(1.000000, 1.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.57,3.47 L15.79,3.47 L15.79,1.47 C15.7846799,1.19609155 15.5639085,0.975320106 15.29,0.97 L5.11,0.97 C4.83385763,0.97 4.61,1.19385763 4.61,1.47 L4.61,2.2 L4.47,2.2 C3.13899375,2.2 2.06,3.27899375 2.06,4.61 L2.06,12.89 C2.04633283,13.7030231 2.3632805,14.4867688 2.93825587,15.0617441 C3.51323124,15.6367195 4.2969769,15.9536672 5.11,15.94 L15.3,15.94 C16.2791594,15.934499 17.0700155,15.1391748 17.07,14.16 L17.07,4 C17.0782787,3.86227481 17.0292781,3.72725023 16.9345977,3.62688898 C16.8399173,3.52652772 16.7079736,3.46975141 16.57,3.47 Z",
  id: "Path",
  fill: "#48A9A1",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#48A9A1",
  x: 3.64,
  y: 3.09,
  width: 10.19,
  height: 2.55
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.83,7.69 L3,7.69 C2.2212785,7.69 1.59,7.0587215 1.59,6.28 C1.59,5.5012785 2.2212785,4.87 3,4.87 L3.14,4.87 L3.14,5.64 C3.14,5.91614237 3.36385763,6.14 3.64,6.14 L15.1,6.14 C15.3761424,6.14 15.6,5.91614237 15.6,5.64 C15.6,5.36385763 15.3761424,5.14 15.1,5.14 L14.32,5.14 L14.32,3.14 C14.3216165,3.00739614 14.2671383,2.88028033 14.17,2.79 C14.0770751,2.69668749 13.9516573,2.642937 13.82,2.64 L3.64,2.64 C3.36385763,2.64 3.14,2.86385763 3.14,3.14 L3.14,3.92 L3,3.92 C1.68827797,3.91971767 0.61721412,4.96856027 0.59,6.28 L0.59,14.56 C0.576332834,15.3730231 0.893280496,16.1567688 1.46825587,16.7317441 C2.04323124,17.3067195 2.8269769,17.6236672 3.64,17.61 L13.83,17.61 C14.8091594,17.604499 15.6,16.8091748 15.6,15.83 L15.6,9.46 C15.6,8.48245599 14.807544,7.69 13.83,7.69 L13.83,7.69 Z M4.14,3.59 L13.33,3.59 L13.33,5.14 L4.14,5.14 L4.14,3.59 Z M14.6,13.42 L11.28,13.42 C10.8858781,13.3751586 10.588176,13.0416646 10.588176,12.645 C10.588176,12.2483354 10.8858781,11.9148414 11.28,11.87 L14.6,11.87 L14.6,13.42 Z M13.83,16.61 L3.63999991,16.61 C2.52738952,16.5828551 1.63966892,15.6729415 1.63999991,14.56 L1.63999991,8.22 C2.0333552,8.51441813 2.50879413,8.67872423 3,8.69 L13.83,8.69 C14.2530068,8.69538928 14.5946107,9.03699316 14.6,9.46 L14.6,10.87 L11.28,10.87 C10.3512685,10.9397584 9.63332292,11.7136523 9.63332292,12.645 C9.63332292,13.5763477 10.3512685,14.3502416 11.28,14.42 L14.6,14.42 L14.6,15.83 C14.6,16.2569069 14.2568718,16.6045268 13.83,16.61 L13.83,16.61 Z",
  id: "Shape",
  fill: "#555150"
})));

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wallet.321e4ab0.svg";
export { ForwardRef as ReactComponent };